<template>
  <v-tooltip bottom>
    <template #activator="{ attrs, on }">
      <div v-bind="attrs" v-on="on">
        {{ price | formatNumberFixed2 }}
      </div>
    </template>

    <div>
      Beregningstidspunkt: {{ calculatedOn | formatDateTime }}
    </div>
    <div>
      Metode: {{ calculationCriteria }}
    </div>
    <div v-if="fixedUntil">
      Låst indtil: {{ fixedUntil | formatDateTime }}
    </div>
  </v-tooltip>
</template>

<script>
export default {
  name: 'PartCustomerPriceDetails',
  props: {
    price: {
      type: Number,
      required: true
    },
    calculatedOn: {
      type: String,
      required: true
    },
    calculationCriteria: {
      type: String,
      required: true
    },
    fixedUntil: {
      type: String
    }
  }
}
</script>